interface AlertDialogState {
  isOpen: boolean
  title?: string
  description?: string
  cancelText?: string
  actionText?: string
  variant?: 'default' | 'destructive'
  onConfirm?: () => void | Promise<void>
  onCancel?: () => void
  width?: string
}

const alertDialogState = ref<AlertDialogState>({
  isOpen: false,
  variant: 'default',
})

export function useAlertDialog() {
  const open = (options: {
    title?: string
    description?: string
    cancelText?: string
    actionText?: string
    variant?: 'default' | 'destructive'
    onConfirm?: () => void | Promise<void>
    onCancel?: () => void
    width?: string
  }) => {
    alertDialogState.value = {
      isOpen: true,
      title: options.title,
      description: options.description,
      cancelText: options.cancelText || 'Batal',
      actionText: options.actionText || 'Lanjutkan',
      variant: options.variant || 'default',
      onConfirm: options.onConfirm,
      onCancel: options.onCancel,
      width: options.width || '',
    }
  }

  const close = () => {
    alertDialogState.value.isOpen = false
  }

  const confirm = async () => {
    await alertDialogState.value.onConfirm?.()
    close()
  }

  const cancel = () => {
    alertDialogState.value.onCancel?.()
    close()
  }

  return {
    state: computed(() => alertDialogState.value),
    isOpen: computed(() => alertDialogState.value.isOpen),
    title: computed(() => alertDialogState.value.title),
    description: computed(() => alertDialogState.value.description),
    cancelText: computed(() => alertDialogState.value.cancelText),
    actionText: computed(() => alertDialogState.value.actionText),
    variant: computed(() => alertDialogState.value.variant),
    width: computed(() => alertDialogState.value.width),
    open,
    close,
    confirm,
    cancel,
  }
}
